import React from 'react';
import ImprimirEgresos from '../../../components/insumos/egresos/ImprimirEgresos';

const ImprimirEgresosPage: React.FC = () => {
  return (
    <div style={{ padding: '20px' , textAlign: 'center' , alignItems: 'center', justifyContent: 'center'}}>
        <h2>Comprobante Egreso</h2>
        <ImprimirEgresos />
    </div>
  );
};

export default ImprimirEgresosPage;